(function() {
    'use strict';

    angular.module('allegro').controller('AllegroSellerUpdateController', AllegroSellerUpdateController);

    AllegroSellerUpdateController.$inject = [
        '$state',
        '$stateParams',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroAccountDataSrvc',
        'allegroSellersDataSrvc',
        'allegroSellerMessagesConst'
    ];

    function AllegroSellerUpdateController(
        $state,
        $stateParams,
        notificationSrvc,
        errorNotificationSrvc,
        allegroAccountDataSrvc,
        allegroSellersDataSrvc,
        allegroSellerMessagesConst
    ){
        var self = this;
        self.loading = false;

        self.serverErrors = {
            account: [],
            tax_id: [],
            company_name: [],
            first_name: [],
            last_name: [],
            street: [],
            city: [],
            zip_code: [],
            logo: []
        };

        self.account = {};
        self.sellerData = {
            pk: null,
            account: null,
            tax_id: '',
            company_name: '',
            first_name: '',
            last_name: '',
            street: '',
            city: '',
            zip_code: '',
            logo: null
        };

        self.getAccount = getAccount;
        self.getSellerData = getSellerData;
        self.updateSeller = updateSeller;
        self.cleanErrors = cleanErrors;

        active();

        function active(){
            self.loading = true;

            self.getSellerData($stateParams.pk).then(function(response) {
                if (response.account) {
                    return self.getAccount(response.account);
                }
            })
            .then(function(data) {
                self.loading = false;
            });
        }

        function getAccount(accountPk) {
            return allegroAccountDataSrvc.get({pk: accountPk})
                .$promise
                .then(function (response) {
                    self.account = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function () {});
        }

        function getSellerData(sellerPk){
            return allegroSellersDataSrvc.get({pk: sellerPk})
                .$promise
                .then(function (response) {
                    self.sellerData = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function updateSeller() {
            allegroSellersDataSrvc.update({pk: self.sellerData.pk}, self.sellerData)
                .$promise
                .then(function(response) {
                    notificationSrvc.notification("success", allegroSellerMessagesConst.update);
                    $state.go('layout.allegro-accounts.detail.settings', {pk: self.account.pk});
                })
                .catch(function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
